// extracted by mini-css-extract-plugin
export var orderDetails = "_ty-2";
export var orderImage = "_ty-1";
export var orderMeta = "_ty-3";
export var orderSummary = "_ty-0";
export var rightArrow = "_ty-4";